﻿window.addEventListener('load', fadeInEffect);

function fadeInEffect() {
    const fadeTarget = document.documentElement;
    fadeTarget.classList.remove('nojs');
}